import { Directive, HostListener } from '@angular/core';
import { Keyboard } from '@ionic-native/keyboard';
import { UtilsServiceProvider } from '../../providers/utils-service/utils-service';

@Directive({
  selector: '[keyboard-input]'
})
export class keyboardInput {
  constructor(
    private keyboard: Keyboard,
    public utilsService: UtilsServiceProvider
  ) {}

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event) {
    if (event.key === 'Enter') {
      if (this.utilsService.isDevice) {
        this.keyboard.hide();
      } else {
        (document.activeElement as HTMLElement).blur();
      }
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/components/keyboard-input/keyboard-input.ts